export const getSiteFromUrl = (url, defaultSite = 'us') => {
  if (url) {
    const fragments = url.split("/");
    if (fragments.length < 4)
      return defaultSite;
    if (['us', 'cl', 'pe', 'mx', 'br', 'co', 'cn'].includes(fragments[3]))
      return fragments[3];
    return defaultSite;
  }
  return defaultSite;
};

export const getSite = () => getSiteFromUrl(window.location.href);

export const siteToLang = site => {
  if (['cl', 'pe', 'mx', 'co'].includes(site))
    return 'es';
  if (site == 'us')
    return 'en';
  if (site == 'br')
    return 'pt';
  if (site == 'cn')
    return 'zh';
  return 'en';
};

export const getLang = () => siteToLang(getSite());
